// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const GENERATE_ANALYSIS_VIEW_URL_STEP_SHAPES = [
  {
    stepType: PipelineStepType.GENERATE_ANALYSIS_VIEW_URL,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      inputDataset: {
        systemName: 'inputDataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      outputUrl: {
        systemName: 'outputUrl',
        displayName: 'Output URL',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      additionalParams: {
        kind: 'array',
        required: false,
        elementSpec: {
          kind: 'shape',
          required: true,
          fields: {
            paramKey: {
              kind: 'enum',
              required: true,
              choices: [
                'showChips',
                'hideSidebar',
                'rawDataIndex',
                'highlightedStepIds',
                'chartId',
                'dataFrameId',
                'fileId'
              ]
            },
            paramValue: {
              kind: 'string',
              required: true
            }
          }
        }
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
